import * as ActionCasesFns from './ActionCasesFns';
import * as CoreFns from './CoreFns';
import * as StandardFns from './StandardFns';
import * as ResponsiveFns from './ResponsiveFns';
import * as DesignerFunctions from './DesignerFunctions';
import * as TypeEvaluation from '../TypeEvaluation';
import * as StyleFunctions from './StyleFunctions';

export function getTitleFromNode(node, currentList, overallPath, coverString, type){
  if (node){
    if (node.x.length > 0){
      var xS = node.x;
      return getNameFromCommitted(xS[0], currentList, false, coverString, type) ;
    }
  }
  return "";
}

export function contractName(currentList, scKey){
    var contractInfo = CoreFns.getContractInfo(currentList, scKey);
    if (contractInfo){
      return contractInfo.contractName;
    }
  return 'Contract not found';
}
export function expandPath(varName, path, currentList, fullName, coverString){
  var counter = 0;
  var ePath = path.map((aP, index)=>{
    if (aP.t === 'l'){
      counter += 1;
      return '[List Item ' + counter + ']';
    }else if (aP.t === 'oP'){
      return '.' + aP.n;
    }else{
      var ins = getNameFromCommitted(aP, currentList, fullName, coverString, {t:'UInteger'});
      return '['+ins+']';
    }
  }).join('');
  return varName + ePath;
}


function getNameFromCommitted(spec, currentList, fullName, coverString, type){

  function pathText(firstNode, type){
    var txtPieces = '';
    var typeToCheck = type;
    firstNode.p.forEach((aP, index)=>{
      if (aP.t === 'oP'){
        var name = '';
        for (var i = 0; i < typeToCheck.c.length; i++){
          if (type.c[i].n === aP.n){
            name = typeToCheck.c[i].n;
            typeToCheck = typeToCheck.c[i].t;
            break;
          }
        }
        txtPieces += '.' + name;
      }else{
        typeToCheck = typeToCheck.c;
        var p = getNameFromCommitted(aP, currentList, fullName, coverString, {t:'UInteger'});
        txtPieces += '[' + p + ']';        
      }
    })
    return txtPieces;
  }

  function getVals(v, interval, inPieces){
    var vals = '';
    for (var i = 0; i < v.length; i++){
      var aVal = getNameFromCommitted(v[i], currentList, fullName, coverString, inPieces[i]);
      if (i > 0){
        vals += interval;
      }
      if (st === 'f' && spec.i === 61){
        var name;
        for (var i5 = 0; i5 < type.c.length; i5++){
          if (type.c[i5].n === spec.v[i].ti){
            name = type.c[i5].n;
          }
        }
        vals += name + ':';
      }
      vals += aVal;
    }
    return vals;
  }

  var st = spec.t;
  
  if (st === 'i' || st === 'ui' || st === 'dc' || st === 'ad'){
    return spec.v;
  }else if (st === 'dt'){

    return StyleFunctions.dispDateOrDateTime(spec.v, true, 'YYYY_MM_DD', '/');
  }else if (st === 's'){
    if (fullName || coverString){
      return '"' + spec.v + '"';
    }else{
      return spec.v;
    }
  }else if (st === 'f'){

    var oTitle;
    var thisFn;
    if (!fullName){
      thisFn = StandardFns.functionalPieces[spec.v];
      if (thisFn){
        oTitle = thisFn.t;
      }

      if (spec.v === 58 || spec.v === 59 || spec.v === 71){
        oTitle += " (List Variable " + spec.m0 + ")";
        if (spec.v=== 71){
          oTitle += " (Start Variable " + spec.m1 + ")";
        }
      }else if (spec.v === 24){
        oTitle += " (Left Variable " + spec.m0 + ") (Right Variable " + spec.m1 + ")";
      }    

      return oTitle;
    }
    thisFn = StandardFns.functionalPieces[spec.i];
    if (thisFn){
      if (thisFn.s){
        oTitle = thisFn.s;
      }else{
        oTitle = thisFn.t;
      }
    }

    var interval = ", ";
    if (spec.i === 14){ interval = " = ";
    }else if (spec.i === 2){ interval = " + ";
    }else if (spec.i === 3){ interval = " - ";
    }else if (spec.i === 4){ interval = " * ";
    }else if (spec.i === 5){ interval = " / ";
    }else if (spec.i === 15){ interval = " >= ";
    }else if (spec.i === 16){ interval = " > ";
    }else if (spec.i === 17){ interval = " <= ";
    }else if (spec.i === 18){ interval = " < ";
    }

    var vals = getVals(spec.v, interval, thisFn.in);

    if (spec.i === 60){
      return '[' + vals + ']';
    }else if (spec.i === 61){
      return '{' + vals + '}';
    }else if (spec.i >= 14 && spec.i <= 18){
      return '(' + vals + ')';
    }else if (spec.i >= 2 && spec.i <= 5){
      return '(' + vals + ')';
    }
    
    

    if (spec.v.length === 0){
      return oTitle;
    }else{
      return oTitle + ' (' + vals + ')'
    }
  }else if (st === 'u'){
    return '[To be filled]'; 
  }else if (st === 'gV'){
    return  expandPath('Governing Value of ' + DesignerFunctions.getItemTitle(currentList, spec.v, 'item'), spec.p, currentList, fullName, coverString); 
  }else if (st === 'pa'){
    return  DesignerFunctions.getItemTitle(currentList, spec.v, 'screen'); 
  }else if (st === 'al'){
    return  DesignerFunctions.getItemTitle(currentList, spec.v, 'alert'); 
  }else if (st === 'pu'){
    var pu = currentList.pu;
    if (pu[spec.v]){
      return pu[spec.v].n;
    }else{
      return 'Invalid Pop Up';
    }
  }else if (st === 'gi'){
    return 'Governing Index ' + findEntityName(spec.v, currentList);
  }else if (st === 'pl'){
    return '[Placeholder : ' + spec.p + '] ' + spec.v;
  }else if (st === 'footer'){
    return 'Footer';
  }else if (st === 'ca'){
    var smartContracts = currentList.sc;
    var thisSc = smartContracts[spec.v];
    if (thisSc){
      var addSet = thisSc.addSet;
      var addSetKeys = Object.keys(addSet);
      return 'Address of ' + addSet[addSetKeys[0]].contractName;
    }
    return 'Invalid contract address as the contract has been deleted';

  }else if (st === 'scr'){
    var feSet = currentList.fe;
    var thisScreen = feSet[spec.v];
    if (thisScreen){
      return 'Page : ' + thisScreen.n;
    }else if (spec.v === '_placeholderPage'){
      return 'Placeholder Page';
    }else{
      return 'Page no longer exists';
    }
  }else if (st === 'mus'){
    var muSet = currentList.mu;
    var thisMusic = muSet[spec.v];
    if (thisMusic){
      return 'Music : ' + thisMusic.n;
    }else{
      return 'Music no longer exists';
    }
  }else if (st === 'coin' || st === 'curr'){
    var opt;
    if (st === 'coin'){
      opt = CoreFns.coins()
    }else if (st === 'curr'){
      opt = CoreFns.currencies();
    }
    for (var i4 = 0; i4 < opt.length; i4++){
      if (opt[i4].i === spec.v){
        return opt[i4].t;
      }
    }
    return 'Unknown';
  }else if (st === 'eS'){
    var thisSpec = ResponsiveFns.getToRelevantAbi(spec, currentList);
    if (thisSpec){
      var nosOutput = thisSpec.outputs.length;
      var txt = contractName(currentList, spec.s) + "." + thisSpec.name;
      if (nosOutput > 1){
        txt += '.' + TypeEvaluation.getOutputFromESOutputs(thisSpec, spec.n).name; 
      }
      if (fullName){
        if (spec.v.length > 1){
          var minusOneVal = CoreFns.filterPathStopBefore(spec.v, spec.v.length - 1);
          var inputTypes = minusOneVal.map((aP, index)=>{
            return TypeEvaluation.convertSCTypeToInternalType(thisSpec.inputs[index], currentList);
          })
          var vS = getVals(minusOneVal, ', ', inputTypes);
          txt += ' (' + vS + ')';
        }        
      }
      return expandPath(txt, spec.p, currentList, fullName, coverString);
    }
    var relevantFn = spec.i.split(' ')[0];
    var contractInfo = CoreFns.getContractInfo(currentList, spec.s);
    if (contractInfo){
      return 'There is no ' + relevantFn + ' function on ' + contractInfo.contractName + '.';
    }else{
      return 'Function refers to a contract that has been removed.';
    }


  }else if (st === 'eV'){
    var thisSpec1 = ResponsiveFns.getToRelevantAbi(spec, currentList);
    if (thisSpec1){
      return expandPath(thisSpec1.name + ' event', spec.p, currentList, fullName, coverString);
    }
    return 'Contract does not exist';
  }else if (st === 'inP'){
    return expandPath(DesignerFunctions.getItemTitle(currentList, spec.v, 'item'), spec.p, currentList, fullName, coverString);
  }else if (st === 'm'){
    return 'Variable ' + spec.v + pathText(spec, type);
  }else if (st === 'aC'){
    return expandPath(ActionCasesFns.getActionCaseTitle(spec.v) + ' ' + spec.v.k, spec.p, currentList, fullName, coverString); 
  }else if (st === 'oVar'){
    var thisOV = currentList.ov[spec.v];
    if (thisOV){
      return expandPath(thisOV.n, spec.p, currentList, fullName, coverString); 
    }else{
      return 'Variable Deleted';
    }
  }else{
    console.log(spec);
    return 'To Be Defined';
  }
}


export function nameAType(type, currentList){
  if (type.t === 'ListType'){
    return 'List ' + nameAType(type.c, currentList);
  // }else if (type.t === 'Mapping'){
  //   return 'Map from ' + nameAType(type.fr, currentList) + ' to ' + nameAType(type.c, currentList);
  // }else if (type.t === 'Struct'){
  //   var structSet = CoreFns.getContractTypes(currentList, 'Struct');
  //   var thisStruct = structSet.functions[type.v];
  //   if (thisStruct){
  //     return 'Struct '  + thisStruct.n;
  //   }
  //   return 'Deleted Struct';
    }else if (type.t === 'Text String' && type.sp === 'image'){
      return 'Image';
    }else if (type.t === 'any'){
      return 'Data';
  }else{
    return type.t;
  }
}

export function getTextOfASpace(relevantSpace, currentList, type){
  try{
    if (relevantSpace.t === 'formula'){
      var name = getNameFromCommitted(relevantSpace.o, currentList, true, true, type);
      return {t:name};
    }else if (relevantSpace.t){
      return {t:relevantSpace.v};
    }else{
      return {t:relevantSpace};
    }
  }catch(err){
    return {t:'Error', e:err.message};
  }
}
export function getTextOfAPath(currentList, path, type){ //this is a cleaner formulation.
    var relevantSpace = CoreFns.goDownPath(currentList, path, 0);
    if (!relevantSpace){
      return "Unspecified";
    }
    return getTextOfASpace(relevantSpace, currentList, type);
}

function findEntityName(key, list){
  if (list.as[key]){
    return list.as[key]._na;
  }else{
    return '';
  }
}

